import React from 'react';
import { trackEvent } from '@/lib/analytics';
import { usePageContext } from '../../../pages/PageContextProvider.jsx';

// <CtaStrip title subtitle button href event /> — a navy strip with a gold
// button, for one call to action in the middle of a Resources article. A
// click sends the Plausible event `event` (default "pricing_cta_click") with
// the prop article=<slug>.
const CtaStrip = ({ title, subtitle, button = 'See pricing', href = '/pricing/', event = 'pricing_cta_click' }) => {
  const { data } = usePageContext();
  const slug = data?.article?.slug;
  return (
    <aside className="rs-cta-strip" aria-label={title}>
      <div>
        <p className="rs-cta-strip-title">{title}</p>
        {subtitle && <p className="rs-cta-strip-sub">{subtitle}</p>}
      </div>
      <a className="rs-cta-strip-btn" href={href} onClick={() => trackEvent(event, slug ? { article: slug } : undefined)}>{button}</a>
    </aside>
  );
};

export default CtaStrip;
